module.exports = "/_next/static/images/4f1153be6ee5442469b1d44a68a75c64-card-and-phone-3d-lg@3x.jpg";